import { createElementVNode as _createElementVNode, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _mergeProps({
    xmlns: "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    "xml:space": "preserve",
    x: "0px",
    y: "0px",
    version: "1.1",
    viewBox: "0 0 44 44",
    class: "icon-fi icon-fi-flag"
  }, _ctx.$attrs), _cache[0] || (_cache[0] = [
    _createElementVNode("g", { class: "" }, [
      _createElementVNode("path", {
        d: "M14,25c0,0,1-1,4-1s5,2,8,2s4-1,4-1V13c0,0-1,1-4,1s-5-2-8-2s-4,1-4,1V25z",
        class: "icon-fi--stroke-linecap-round icon-fi--stroke-linejoin-round icon-fi--no-fill icon-fi--with-stroke"
      }),
      _createElementVNode("line", {
        x1: "14",
        x2: "14",
        y1: "32",
        y2: "25",
        class: "icon-fi--stroke-linecap-round icon-fi--stroke-linejoin-round icon-fi--no-fill icon-fi--with-stroke"
      })
    ], -1)
  ]), 16))
}
export default { render: render }